<template>
    <Layout>
        <div class="container m_height">
            <!-- <div class="d-flex justify-content-center align-items-center mt-5">
                <div class="session_box alert alert-warning">
                    <span class="fa fa-warning fa-fw"></span>
                    Your Session will expire in <strong> 17 Minutes!</strong>
                </div>
            </div> -->

            <div class="registration_steps text-justify">
                <h1 class="cl_gr text-uppercase my-3">Reset password</h1>
                <p>
                    Please enter new password then click <span class="cl_gr">"RESET"</span> button.
                </p>
                <p>
                    Password should be 6 characters at least
                </p>
            </div>
            <form class="register_form" @submit="resetPasswordSubmitted">
                <div class="alert alert-danger" v-if="errorMsg != ''">
                     {{ errorMsg }}
                </div>
                <div class="alert alert-success" v-if="successMsg != ''">
                     <p>{{ successMsg }}</p>
                     <p>You will redirect to login page in {{ redirect_seconds }}</p>
                </div>

                <div class="form-group required">
                    <div class="row">
                        <div :class="{ 'has-error': $v.username.$error, 'col-sm-12':true }">
                            <label for="username">Username</label>
                            <input v-model="username" name="username" type="text" class="form-control" id="username">
                            <small class="text-danger" v-if="!$v.username.required">Field is required</small>
                        </div>
                        <div :class="{ 'has-error': $v.password.$error, 'col-sm-12':true }">
                            <label for="password">Password</label>
                            <input v-model="password" name="password" type="password" class="form-control" id="password">
                            <small class="text-danger" v-if="!$v.password.required">Field is required</small>
                            <small v-if="!$v.password.minLength"
                                                class="text-danger">Password must have at least 6 letters.</small>
                        </div>
                        <div :class="{ 'has-error': $v.password_confirmation.$error, 'col-sm-12':true }">
                            <label for="password_confirmation">Password Confirmation</label>
                            <input v-model="password_confirmation" name="password_confirmation" type="password" class="form-control" id="password_confirmation">
                            <small class="text-danger" v-if="!$v.password_confirmation.required">Field is required</small>
                            <small class="text-danger" v-if="!$v.password_confirmation.sameAs">Passwords must be identical.</small>
                        </div>


                    </div>
                </div>
              <button type="submit" class="btn btn-success mt-3">Reset</button>
              <a href="/auth/login" type="submit" class="btn btn-danger mt-3 ml-3">Login</a>

            </form>
        </div>



    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { required, requiredIf ,sameAsPassword, sameAs, minLength, email, numeric } from 'vuelidate/lib/validators'
import Api from '@/Api'
var Timer = require('easytimer')
export default {
    name: 'ResetPassword',
    components: {Layout},
    data() {
        return {
            token:'',
            username:'',
            password:'',
            password_confirmation:'',
            errorMsg:'',
            successMsg:'',
            redirect_seconds: null
        };
    },
    validations: {
        username: {required},
        password : { required, minLength:minLength(6) },
        password_confirmation : { required, sameAs: sameAs('password') },

    },
    methods: {
        resetPasswordSubmitted: function(e){
            e.preventDefault();
            if (this.$v.$invalid)
                return;
            var scope = this;
            this.errorMsg = '';
            this.successMsg = '';
            let data = {
              username: this.username,
              password: this.password,
              token: this.token,
              password_confirmation: this.password_confirmation
            };
            Api().post(`auth/password/reset` , data)
                .then(res => {
                    this.successMsg = res.data.message
                    this.setupTimer();
                })
                .catch((error) => {
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;
                            scope.errorMsg = err.errors[0].message;
                        }
                    }
                });
        },
        setupTimer() {
            var timer = new Timer();
            let timerInSeconds = 10;
            timer.start({countdown: true, startValues: {seconds: timerInSeconds }});
            this.redirect_seconds = timer.getTimeValues().toString();
            timer.addEventListener('secondsUpdated', (e) => this.redirect_seconds = timer.getTimeValues().toString() );
            timer.addEventListener('targetAchieved', function (e) {
                alert('You will redirect to login page now');
                window.location.replace('/auth/login');
            });
        }
    },
    mounted() {
        let location = window.location;
        let url = new URL(location.href);
        let token = url.searchParams.get('token');
        if (token == '' || token == undefined) {
            alert('There is no token... you will redirect to reset your password.');
            window.location.replace('/auth/password/email');
            return;
        }
        this.token = token;
    }
};
</script>
